var CreateAssetRequestModel = /** @class */ (function () {
    function CreateAssetRequestModel() {
    }
    return CreateAssetRequestModel;
}());
export { CreateAssetRequestModel };
